"use client";

import { useMemo } from "react";
import { usePortalPreferences } from "../components/PortalPreferences";
import { createPortalTranslator } from "./messages";

export function usePortalTranslations() {
  const { locale } = usePortalPreferences();
  return useMemo(() => createPortalTranslator(locale), [locale]);
}
